export const translations = {
  ar: {
    nav: { home: "الرئيسية", about: "عن الشركة", products: "منتجاتنا", shop: "المتجر", contact: "تواصل معنا" },
    hero: {
      title: "يـام انترناشونال للصناعات",
      sub: "ثقة تُبنى يومًا بعد يوم لدى العائلات والشركات علامات تجارية مبتكرة تضيف قيمة حقيقية للأسواق وراحة ملموسة للحياة اليومية .",
      btn: "تصفح المنتجات"
    },
    about: {
      title: "عن يـام  انترناشونال للصناعات ",
      description: "نحن مصنع من الجيل الثالث، نعد من أكثر المصانع تخصصاً في أسواق الشرق الأوسط وأفريقيا. بطاقة إنتاجية تصل إلى 25,000 طن سنوياً، نستخدم أحدث تقنيات التشغيل الألمانية لإنتاج المنظفات، المطهرات، ومستحضرات التجميل.",
      license: "مرخصون من قبل شراكة استراتيجية مع ERA IG International في ألمانيا (رقم 2019/2).",
      export: "نجحنا في غزو الأسواق الخارجية والتصدير لأكثر من 14 دولة."
    },

  },
  en: {
    nav: { home: "Home", about: "About Us", products: "Products", shop: "Shop", contact: "Contact" },
    hero: {
      title: "YAM International Industries",
      sub: "Trusted by families and businesses, day after day Innovative brands that add real value to markets and bring everyday comfort to homes",
      btn: "Explore Products"
    },
    about: {
      title: "About YAM International",
      description: "A remarkable third-generation factory, leading specialized manufacturing in Middle East and Africa. With 25,000 tons annual capacity, we use modern German technologies for detergents, disinfectants, and cosmetics.",
      license: "Licensed through a strategic partnership with ERA IG International in Germany (No. 2019/2).",
      export: "Managed to conquer foreign markets for export in more than 14 countries."
    },
    stats: { production: "25,000 Tons", countries: "14+ Countries", tech: "German Tech" },
    // إضافات البراندات والتصنيفات
    brands_title: "Our Brands",
    categories: {
      car_care: "Car Care",
      detergents: "Detergents",
      disinfectants: "Disinfectants",
      cosmetics: "Cosmetics"
    },
    brand_names: ["Baseel", "Rghawy", "XClor", "Mival", "Tany", "C-Plus"]
  }
};